<template>
  <div class="tip-page">
    <div class="tip-page-top">
      <i @click="handleCloseTip" class="icon el-icon-close"></i>
      <div class="topLabel">
        <span>途径位置：</span>
        <span>{{ data.deviceName }}</span>
      </div>
      <div class="topLabel">
        <span>途径次数：</span>
        <span>{{ (data.child && data.child.length) || 1 }}</span>
      </div>
    </div>
    <div class="tip-page-content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column
          type="index"
          align="center"
          header-align="center"
          label="序号"
        ></el-table-column>
        <el-table-column prop="date" label="途径时间" width="150">
        </el-table-column>
        <el-table-column
          prop="img"
          label="抓拍图片"
          v-if="data.trajectoryType != 'vehicle'"
        >
          <template slot-scope="scope">
            <img
              :src="scope.row.img"
              @click="handleShowImg(scope.row.img, $event)"
              onerror="this.src='/images/theme/newDark/default.png'"
              style="height: 40px; width: 50px; cursor: pointer"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              title="录像"
              style="font-size: 18px; color: #fff"
              icon="el-icon-video-camera"
              @click="handleView(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { Bus } from "$utils";
export default {
  name: "tip",
  components: {},
  data() {
    return {
      tableData: [],
      data: {}, //渲染数据
    };
  },
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    handleView(item) {
      console.log(item);
      this.$app.AppInstance.handleMiniPlay({
        playType: "back", // 'live',
        playTitle: item.deviceName, //摄像机名称
        playId: item.deviceCode, //摄像机id
        startTime: item.startTime || new Date().getTime() - 60 * 1000, //如果没有时间默认最新一分钟
        endTime: item.endTime || new Date().getTime(),
      });
    },
    handleShowImg(val) {
      this.$app.AppInstance.handleShowViewer([val]);
    },
    handleCloseTip() {
      this.$emit("tipClose");
    },
    handleSetData(data) {
      this.data = { ...data };
      this.tableData = this.data.child.map((item) => {
        return {
          date: item.recordTime4Sort || item.fullTime,
          img: item.face_img_url || item.rimageUrl,
          ...item,
        };
      });
      console.log("提示窗", this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
@keyframes rotation {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}
.flex-Between {
  display: flex;
  justify-content: space-between;
}
$bgcolor: rgba(30, 40, 64, 1);
.tip-page {
  min-width: 250px;
  height: auto;
  border-radius: 5px;
  background: rgba(24, 31, 46, 0.65);
  backdrop-filter: blur(2px);
  padding: 20px 20px;
  &-top {
    // padding: 12px;
    .topLabel {
      margin: 0px 0px 15px;
    }
    i {
      font-size: 18px;
      color: #fff;
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      &:hover {
        background: $bgcolor;
        border-radius: 50%;
        -webkit-animation: rotation 5s linear infinite;
        animation: rotation 5s linear infinite;
      }
    }
  }
  &-content {
    // padding: 0 12px;
    .item-content {
      padding: 5px 0;
      margin: 5px 10px;
      display: flex;
      flex-direction: row;
    }
    .item-label {
      color: #ccc;
      width: 90px;
      margin-right: 10px;
    }
    .item-value {
      max-width: 220px;
    }
  }
}
</style>